import { useContext, useState } from "react";
import { CraftIdentityContext } from "pages/CraftIdentity";
import placeholderPic from "assets/img/craft/craft-card-placeholder.svg";
import CraftingIdentityPopup from "./CraftingIdentityPopup";
import { createAPI } from "services/api/api";
import CommonItemInfo from "components/common-item/CommonItemInfo";
import CraftBlockRarity from "components/crafting/CraftBlockRarity";
import { useSoundPath } from "hooks/useSoundPath";
import CraftBlockIdentityTooltip from "./CraftBlockIdentityTooltip";
import CraftBlockItemTooltip from "components/crafting/CraftBlockItemTooltip";

const CraftBlockIdentity = () => {
  const api = createAPI();
  const [isCraftLoading, setIsCraftLoading] = useState(false);
  const [isCraft, setIsCraft] = useState(false);
  const [craftingStep, setCraftingStep] = useState("submit");
  const [craftedIdentity, setCraftedIdentity] = useState({});
  const [errorText, setErrorText] = useState("");
  const playSound = useSoundPath();
  const {
    activeBlock,
    setActiveBlock,
    clearBlock,
    clearBlocks,
    craftBlocks,
    matchesLength,
    selectedName,
  } = useContext(CraftIdentityContext);

  const submitHandler = (e) => {
    e.preventDefault();

    setIsCraftLoading(true);
    playSound("crafting");

    const payload = {
      nft_card_category_id: craftBlocks[0].value.id,
      nft_card_month_id: craftBlocks[1].value.id,
      nft_card_day_id: craftBlocks[2].value.id,
      nft_card_year_id: craftBlocks[3].value.id,
      celebrity_id: selectedName.id,
    };

    api
      .post("/nft/craft_identity", payload)
      .then((res) => {
        if (res.status === 200) {
          setCraftingStep("success");
          setCraftedIdentity(res.data);
          setIsCraftLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsCraftLoading(false);
        setCraftingStep("fail");
        setErrorText(error.response.data);
      });
  };

  const clearButton = craftBlocks.some((obj) => obj.value !== null) ? (
    <button
      className="craft-block__clear"
      onClick={() => {
        clearBlocks();
        setActiveBlock("Category");
        playSound("clearing");
      }}
    >
      Clear all slots
    </button>
  ) : null;

  const isSubmitDisabled =
    matchesLength !== null &&
    matchesLength > 0 &&
    craftBlocks.every((item) => item.value !== null)
      ? false
      : true;

  return (
    <>
      <section className="craft-block">
        <header className="craft-block__header">
          <section className="craft-block__header-info">
            <h1 className="craft-block__title">
              Craft an identity
              <CraftBlockIdentityTooltip />
            </h1>
            <p className="craft-block__descr">
              Slot a Category card to see Identity matches, then slot the month,
              day and year cards needed to craft it.
            </p>
          </section>
          <div className="craft-block__actions">
            {clearButton}
            <button
              className={`craft-block__submit ${craftBlocks.every((item) => item.value === null) ? '' : 'craft-block__submit--enabled'}`}
              disabled={isSubmitDisabled}
              onClick={() => {
                playSound("main");
                setIsCraft(true);
              }}
            >
              Craft Identity
            </button>
          </div>
        </header>
        <ul className="craft-block__steps">
          {craftBlocks.map((block) => (
            <li
              className={`craft-block__step
                ${block.placeholder === activeBlock ? "active" : ""}
                ${block.value !== null ? 'craft-block__step--filled' : ''}
              `}
              key={block.placeholder}
              onClick={() => setActiveBlock(block.placeholder)}
            >
              {block.value === null ? (
                <p className="craft-block__step-empty">
                  <img src={placeholderPic} alt="" />
                  <span>{block.placeholder}</span>
                </p>
              ) : (
                <>
                  <CraftBlockItemTooltip item={block.value} />
                  <div className="craft-block__step-selected">
                    <CommonItemInfo
                      image={block.value.image}
                      name={block.value.name}
                      props={block.value.properties}
                      type={block.value.tag}
                    />
                    <p className="cards-list__block-item-text">
                      {block.value.name}
                    </p>
                    <span className="craft-block__step-tag">
                      {block.value.tag}
                    </span>
                    <button
                      className="craft-block__step-clear"
                      onClick={() => {
                        clearBlock(block);
                        playSound("clearing");
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
        <CraftBlockRarity />
      </section>

      {isCraft && (
        <CraftingIdentityPopup
          setIsCraft={setIsCraft}
          submitHandler={submitHandler}
          craftingStep={craftingStep}
          setCraftingStep={setCraftingStep}
          craftedIdentityId={craftedIdentity}
          isCraftLoading={isCraftLoading}
          errorText={errorText}
        />
      )}
    </>
  );
};

export default CraftBlockIdentity;
